function hud() {
	console.log("HUD init");
}

export {
	hud
}